import { createStyles, makeStyles } from "@mui/styles";

export const useFormStyles = makeStyles(() =>
  createStyles({
    container: {
      // width: "100%"
    },
    field_container: {
      // marginBottom: "15px",
      // width: "100%"
    },
    field: {
      // width: "100%",
      // color: "red"
    },
    datepicker_container: {
      // margin: "20px",
      // width: "90%",
    },
    datepicker: {
    },
    button: {
      // float: "right",
      // fontSize: 14,
      // letterSpacing: 1,
      // display: "flex",
      // flexDirection: "row",
      // borderRadius: 5
      /*"& .MuiButton-root.Mui-disabled": {
        "&:hover": {
          color: "rgba(0, 0, 0, 0)",
          backgroundColor: "rgba(0, 0, 0, 0)"
        }
      },
      "& .MuiButton-root.Mui-enabled": {
        "&:hover": {
          //backgroundColor: "rgba(0, 0, 0, 0.1)",
          backgroundColor: 'black',
          //color: "black"//"rgba(0, 0, 0, 0.1)"
        }
      }*/
    }
  })
);
